import { createContext, useCallback, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({
  theme: "brutal",
  toggle: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "brutal";
    return localStorage.getItem("elarte-theme") || "brutal";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "editorial") {
      root.setAttribute("data-theme", "editorial");
    } else {
      root.removeAttribute("data-theme");
    }
    localStorage.setItem("elarte-theme", theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => (t === "brutal" ? "editorial" : "brutal"));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
